import { Footer } from '#components/Footer.tsx'
import { Navbar } from '#components/Navbar.tsx'
import { useAuth } from '#context/Auth.tsx'
import { validatingFetch } from '#utils/validatingFetch.ts'
import { toTeamId } from '@nrfcloud/account-service-proto/domain'
import { TeamResponse } from '@nrfcloud/account-service-proto/user'
import type { StaticDecode } from '@sinclair/typebox'
import { useEffect, useState } from 'preact/hooks'
import { TeamCard } from '../components/TeamCard.tsx'

export const Team = (props: { team: string }) => {
	const { oidcUser } = useAuth()
	const [teamProfile, setTeamProfile] = useState<{
		team: StaticDecode<typeof TeamResponse>
		version: string
	}>()

	useEffect(() => {
		if (oidcUser?.id_token === undefined) return
		validatingFetch(TeamResponse)(
			new URL(`/2025-06-30/team/${props.team}`, ACCOUNT_API_URL),
			undefined,
			'GET',
			{
				Authorization: oidcUser.id_token,
			},
		).ok((team, { response }) => {
			setTeamProfile({
				team,
				version: response.headers.get('etag') ?? '',
			})
		})
	}, [oidcUser])

	return (
		<>
			<Navbar />
			<main class="container">
				<div class="row justify-content-center">
					<div class="col-md-5">
						<TeamCard id={toTeamId(props.team)} profile={teamProfile} />
					</div>
				</div>
			</main>
			<Footer />
		</>
	)
}
